export default {
  title: 'עריכת הסכמים של הסוכן {1}',
  from: 'מתאריך',
  till: 'עד תאריך',
  number: 'מספר הסכם',
  agent: 'מספר סוכן',
  company: 'חברה מנהלת',
  branch: 'מוצר',
  branches: 'מוצרים',
  addAgreement: 'הוספת הסכם',
  accordType: 'סוג הסכם',
  accordName: 'שם הסכם',
  comments: 'הערות',
  verifyDeletion: 'האם אתה בטוח שברצונך למחוק את ההסכם?',
  successDelete: 'ההסכם נמחק בהצלחה',
  failureDelete: 'מחיקת ההסכם נכשלה',
  commision: {
    agentFeeMonthlyDeposit: 'עמלת סוכן נפרעים מהפקדה %',
    agentFeeMonthlyAccumulation: 'עמלת סוכן נפרעים מצבירה %',
    agentFeeAnnualAccumulation: 'עמלת סוכן היקף מצבירה %',
    agentFeeAnnualDeposit: 'עמלת סוכן היקף מהפקדה %',
    employeeAgentCommission: 'עמלת סוכן שכיר %',
  },
};
